import { Shield, Lock, Flame } from 'lucide-react'

export function TrustIndicators() {
  const indicators = [
    {
      icon: <Lock className="w-5 h-5 text-primary" />,
      label: '256-bit AES-GCM Encryption'
    },
    {
      icon: <Shield className="w-5 h-5 text-accent" />,
      label: 'Zero-Knowledge Architecture'
    },
    {
      icon: <Flame className="w-5 h-5 text-destructive" />,
      label: 'Burn-After-Read'
    }
  ]

  const stats = [
    { value: '256-bit', label: 'Encryption Strength' },
    { value: '0', label: 'Keys on Server' },
    { value: '500MB', label: 'Max File Size' },
    { value: '30 days', label: 'Max Storage Time' }
  ]

  return (
    <>
      {/* Trust Badges */}
      <div className="flex flex-col sm:flex-row flex-wrap justify-center items-center gap-4 sm:gap-8 mb-8 text-sm sm:text-base">
        {indicators.map((indicator, i) => (
          <div key={i} className="flex items-center gap-2">
            {indicator.icon}
            <span className="text-muted-foreground">{indicator.label}</span>
          </div>
        ))}
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-6 mb-8 sm:mb-12 max-w-2xl mx-auto">
        {stats.map((stat, i) => (
          <div key={i} className="text-center p-3 sm:p-4 bg-card rounded-card border border-border">
            <div className="text-xl sm:text-2xl font-mono font-semibold text-primary">
              {stat.value}
            </div>
            <div className="text-xs sm:text-sm text-muted-foreground mt-1">
              {stat.label}
            </div>
          </div>
        ))}
      </div>
    </>
  )
}